import React from "react";
import { useTheme } from "../../../hooks";
import { ButtonSizes } from "../../../types";
import Button, { ButtonProps, InButtonOverrideStyles } from "../Button";
import { FabContainer, FabDefaultStyles, FabStyles } from "./FabStyles";

export type ButtonStylesOverrides = {
  bottom?: number;
  right?: number;
};

type FabProps = ButtonProps & {
  fabStyles?: ButtonStylesOverrides;
};

const getButtonSize = (size: ButtonSizes): number => {
  switch (size) {
    case "sm":
      return 20;
    case "lg":
      return 40;
    case "md":
    default:
      return 30;
  }
};

const Fab: React.FC<React.PropsWithChildren<FabProps>> = ({
  children,
  fabStyles = {},
  variant = "default",
  size = "md",
  ...rest
}) => {
  const { Theme } = useTheme();
  const StylesOverrides: FabStyles = { ...FabDefaultStyles, ...fabStyles };

  const buttonSize: number = getButtonSize(size);
  const fabButtonStyles: InButtonOverrideStyles = {
    button: {
      ...Theme.button[variant],
      padding: `${buttonSize / 2}px`,
      "border-radius": `${buttonSize}px`,
      "line-height": "1",
      boxShadow: "0 3px 8px 0 #77879a",
    },
  };
  return (
    <FabContainer styles={StylesOverrides}>
      <Button {...rest} variant={variant} styles={fabButtonStyles}>
        {children}
      </Button>
    </FabContainer>
  );
};

export default Fab;
